<template lang="pug">
dv-menu(left)
  template(#activator="{ attrs, on }")
    v-sheet.rounded-pill.ui-background.pa-1.d-flex.align-center.gap-8.pointer(
      :height="36"
      v-on="on"
    )
      app-avatar.rounded-circle.header-user-data__avatar(
        :size="32"
        :avatar="avatar"
      )
      v-icon.mr-2(color="ui-neutral" :size="20") $ui-bars-3
  v-list.ui-body-1.pb-0
    template(v-if="links.length")
      v-list-item(
        v-for="(link, idx) in links"
        :key="idx"
        :to="link.to"
        color="ui-primary"
      )
        v-icon(:size="20") {{ link.icon }}
        p.ml-4 {{ link.text }}
      v-divider
    v-list-item.ui-error--text(
      @click="logout"
    )
      v-icon(size="20") $iexit
      p.ml-4 Выйти
</template>

<script>
import AppAvatar from '@/components/user-redesign/AppAvatar.vue';
import DvMenu from '@/packages/ui/components/menus/DvMenu.vue';

export default {
  components: {
    AppAvatar,
    DvMenu,
  },
  props: {},
  computed: {
    avatar() {
      const { profile, organizer } = this.$user?.data || {};
      const base = profile || organizer || {};
      return base?.avatar || {};
    },
    links() {
      if (!this.$user.isOrganization) return [];
      return [
        {
          icon: '$iuser',
          to: { name: 'ui-profile' },
          text: 'Профиль',
        },
        {
          icon: '$iinfo',
          to: { name: 'ui-instructions' },
          text: 'Инструкции',
        },
        {
          icon: '$ifolder-favorite-outline',
          to: { name: 'organization-associations' },
          text: 'Ассоциации',
        },
      ];
    },
  },
  methods: {
    logout() {
      this.$dialogs.confirm({
        attrs: {
          method: async () => {
            await this.$store.dispatch('auth/logout');
            this.$router.push('/');
          },
          isRequest: false,
          message: 'Вы уверены, что хотите выйти из учётной записи?',
          closeBtnAttrs: {
            'btn-text': 'Остаться',
          },
          confirmBtnAttrs: {
            'btn-text': 'Выйти',
          },
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header-user-data {
  &__avatar {
    border: 2px solid rgba(0, 0, 0, 0.10);
  }
}
</style>
